type Language = {
  code: string;
  name: string;
  isDefault?: boolean;
};

function validateLanguages<T extends readonly Language[]>(languages: T): T {
  const defaultCount = languages.filter((lang) => lang.isDefault).length;
  if (defaultCount !== 1) {
    throw new Error(`Expected only one default language, got ${defaultCount}`);
  }
  return languages;
}

export const LANGUAGES = validateLanguages([
  { code: 'nl', name: 'Nederlands', isDefault: true },
  { code: 'en', name: 'English', isDefault: false },
] as const);

export type SupportedLanguage = (typeof LANGUAGES)[number]['code'];

export const getDefaultLanguage = (): SupportedLanguage => {
  const defaultLang = LANGUAGES.find((lang) => lang.isDefault);
  return (defaultLang?.code as SupportedLanguage) || 'nl';
};

export const getSupportedLanguageCodes = (): SupportedLanguage[] => {
  return LANGUAGES.map((lang) => lang.code as SupportedLanguage);
};
